import React from "react";
import { Segmented } from "antd";

const InvoiceSmallTabs = ({ selectedStatus, setSelectedStatus }) => {
    return (
        <Segmented
            block
            value={selectedStatus}
            onChange={setSelectedStatus}
            options={[
                { label: "Alle", value: "all" },
                { label: "Überfällig", value: "überfällig" },
                { label: "Mit Skonto", value: "mitSkonto" }
            ]}
            style={{
                width: "100%",
            }}
        />
    );
};

export default InvoiceSmallTabs;